import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { PublicPageShell } from "@/components/PublicPageShell";
import { api } from "@/lib/api";

export default function PublicHistory() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api
      .get("/public/history-items")
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, []);

  const categorias = [...new Set((items || []).map((i) => i.categoria || "Geral"))];

  return (
    <PublicPageShell testId="historia-page">
      <section className="bg-[#0A0A0A] py-16 lg:py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-primary" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Desde 2006</span>
          </div>
          <h1 className="mt-4 font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-testid="historia-title">
            Nossa História
          </h1>
          <p className="mt-3 max-w-2xl text-sm text-zinc-400">
            Registros, fotografias, vídeos, reportagens, apresentações e documentos do Instituto Musical Jacaré.
          </p>
        </div>
      </section>

      <section className="py-14 lg:py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          {items === null && <p className="text-sm text-muted-foreground">Carregando...</p>}
          {items !== null && items.length === 0 && (
            <p className="border border-dashed border-border p-8 text-center text-sm text-muted-foreground" data-testid="historia-empty">
              Estamos organizando nosso acervo histórico. Em breve, novidades por aqui.
            </p>
          )}
          {categorias.map((cat) => (
            <div key={cat} className="mb-12" data-testid={`historia-categoria-${cat}`}>
              <h2 className="font-heading text-xl font-bold">
                <span className="mr-2 inline-block h-4 w-1 bg-primary" />
                {cat}
              </h2>
              <div className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {items
                  .filter((i) => (i.categoria || "Geral") === cat)
                  .map((i) => (
                    <article key={i.id} className="border border-border bg-white" data-testid={`historia-item-${i.id}`}>
                      {i.capa_url && (
                        <img src={i.capa_url} alt={i.titulo} className="aspect-[16/9] w-full object-cover" loading="lazy" />
                      )}
                      <div className="p-4">
                        <p className="text-xs font-semibold uppercase tracking-wider text-primary">{i.data_ref || "—"}</p>
                        <h3 className="mt-1 font-heading text-base font-bold">{i.titulo}</h3>
                        {i.descricao && <p className="mt-2 text-sm text-muted-foreground">{i.descricao}</p>}
                        {i.url && (
                          <a
                            href={i.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-primary transition-colors hover:underline"
                            data-testid={`historia-link-${i.id}`}
                          >
                            Acessar registro <ExternalLink size={14} />
                          </a>
                        )}
                      </div>
                    </article>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </PublicPageShell>
  );
}
